import React from 'react';
import styled, { css } from 'styled-components';
import InputMask from 'react-input-mask';

import constants from '~/constants.js';

const Form = styled.form`
  text-align: 'center';
`;

const Group = styled.div`
  width: 256px;
  margin: 0 auto 1rem;
  text-align: left;
`;

const Label = styled.label`
  display: inline-block;
  margin-bottom: 0.25rem;
  padding-left: 0.25rem;
`;

const Help = styled.span`
  display: inline-block;
  padding-left: 0.25rem;
  font-size: 0.9rem;
  color: ${constants.colors.primaryDark};
  white-space: pre-wrap;
`;

const Error = Help.extend`
  color: ${constants.colors.maroon};
`;

Form.Group = props => (
  <Group>
    <Label htmlFor={props.id}>{props.label}</Label>
    {React.cloneElement(props.children, {
      id: props.id,
      hasError: !!props.error,
    })}
    {props.help && <Help>{props.help}</Help>}
    {props.error && <Error>{props.error}</Error>}
  </Group>
);

const inputStyle = css`
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid;
  border-color: ${props =>
    props.hasError ? constants.colors.maroon : 'rgba(0,0,0,.15)'};
  border-radius: 3px;
  background-color: ${constants.colors.white};
  font-size: 16px;
  line-height: 1.618;

  ${props => (props.secure ? '-webkit-text-security: disc;' : '')}
    ::-webkit-input-placeholder {
    font-size: 13px;
  }
  ::-moz-placeholder {
    font-size: 13px;
  }
  :-ms-input-placeholder {
    font-size: 13px;
  }
  :-moz-placeholder {
    font-size: 13px;
  }
`;

Form.Input = styled.input`
  ${inputStyle};
`;

Form.MaskedInput = styled(({ hasError, secure, onChange, ...rest }) => (
  <InputMask
    {...rest}
    onChange={event => {
      event.target.value = event.target.value.replace(/\s/g, '');
      onChange(event);
    }}
  />
))`
  ${inputStyle};
`;

Form.Submit = styled.button`
  display: inline-block;
  margin-top: 1rem;
  width: 256px;
  padding: 0.5rem 1rem;
  border: 1px solid transparent;
  border-radius: 3px;
  color: ${constants.colors.white};
  background-color: ${constants.colors.primaryLight};
  line-height: 1.618;
  text-align: center;
  transition: background 0.15s ease;
  cursor: pointer;

  &:hover {
    background-color: ${constants.colors.primary};
  }

  &:disabled {
    background-color: ${constants.colors.mercury};
    color: ${constants.colors.charcoal};
  }
`;

export default Form;



// WEBPACK FOOTER //
// ./src/components/Login/Form.js